import { render, staticRenderFns } from "./CustomerManageAdd.vue?vue&type=template&id=11fdf5f0&scoped=true"
import script from "./CustomerManageAdd.vue?vue&type=script&lang=js"
export * from "./CustomerManageAdd.vue?vue&type=script&lang=js"
import style0 from "./CustomerManageAdd.vue?vue&type=style&index=0&id=11fdf5f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fdf5f0",
  null
  
)

export default component.exports